/* eslint-disable */
import moment from 'moment'
import 'moment-timezone'
import { getHolidayByDate } from 'feiertagejs';

function checkStatus (data) {
    var dn = moment().tz('Europe/Berlin')

    // Get day number
    var day_number = dn.day() == 7 ? 0 : dn.day()
    // Special info
    var hspecial_info = Object
    // Lunch info
    var hlunch_info = {
        check: false
    }


    // Get Holiday
    var federal_state =  data.federal_state
    var splitted_state = federal_state.split('_')
    var state='all'
    var holiday = ''
    if(splitted_state.length>1){
        state= splitted_state[1].toUpperCase()
    }

    if(getHolidayByDate(dn.toDate(), state.toUpperCase())){
        holiday = getHolidayByDate(dn.toDate(), state.toUpperCase()).trans()
    }

    // Check special business hour
    for (var i = 0; i < data.special_hours.length; i++) {
        var value = data.special_hours[i]
        var dss = moment.unix(value['special_hour_start']).tz('Europe/Berlin')
        var dse = moment.unix(value['special_hour_end']).tz('Europe/Berlin')
        var message = value['special_hour_text']

        var period = moment.duration(dse.diff(dss))
        if (parseInt(period.asDays()) > 0) {
            let inRangeDay = checkInRangeDay(dss.format('MM/DD/YYYY'), dse.format('MM/DD/YYYY'), dn.format('MM/DD/YYYY'))
            if (inRangeDay) {
                let dts = stringToDateTime('0000')
                let dte = stringToDateTime('2359')
                if (checkInRangeDate(dn, dts, dte)) {
                    return {
                        'status': value['special_hour_type'],
                        'text': 'bis ' + dse.format('DD-MM-YYYY'),
                        'message': message
                    }
                }
            }
        } else {
            if (checkInRangeDate(dn, dss, dse)) {
                return getCheckerbyDates(dn, dss, dse, value['special_hour_type'], message, hlunch_info, hspecial_info)
            }
            let interval = moment.duration(dn.diff(dss))
            if (parseInt(interval.asDays()) == 0 && dn == dss) {
                hspecial_info['type'] = value['special_hour_type']
                hspecial_info['message'] = message
                hspecial_info['date_start'] = dss
                hspecial_info['date_end'] = dse
            }
        }
    }
    // Check if public holiday
    if (holiday !== '') {
    // Overwrite if special hour is ready in the same day
        if (hspecial_info['type'] == 'open') {
            return {
                'status': 'opening',
                'text': 'Heute um ' + hspecial_info['date_start'].format('H:mm') + ' Uhr',
                'message': hspecial_info['message']
            }
        } else {
            return {
                'status': 'closed',
                'text': 'Feiertag',
                'message': holiday
            }
        }
    }

    // Check lunch hour
    if (checkifExistWorkingDay(data.opening_hours, day_number)) {
        for (var i = 0; i < data.lunch_break.length; i++) {
            var value = data.lunch_break[i]
            // Check if we are on current day number
            if (value['day'] == day_number) {
                let dls = stringToDateTime(value['starthours'])
                let dle = stringToDateTime(value['endhours'])
                if (checkInRangeDate(dn, dls, dle)) {
                    hlunch_info['check'] = true
                    return getCheckerbyDates(dn, dls, dle, 'closed', '', hlunch_info, hspecial_info)
                }
                // Fill lunch info if lunch time start in less than one hour
                let interval = moment.duration(dn.diff(dls))
                if (parseInt(interval.asHours()) == 0) {
                    hlunch_info['check'] = true
                    hlunch_info['date_start'] = dls
                    hlunch_info['date_end'] = dle
                }
            }
        }
    }

    // Check business hours
    // With upcoming business and lunch hour
    for (var i = 0; i < data.opening_hours.length; i++) {
        var value = data.opening_hours[i]
        // Check if we are on current day number
        if (value['day'] == day_number) {
            let dbs = stringToDateTime(value['starthours'])
            let dbe = stringToDateTime(value['endhours'])
            return getCheckerbyDates(dn, dbs, dbe, 'open', '', hlunch_info, hspecial_info)
        }
    }

    // Special upcoming hour
    if (hspecial_info['type'] == 'open') {
        return {
            'status': 'opening',
            'text': 'Heute um ' + hspecial_info['date_start'].format('H:mm') + ' Uhr',
            'message': hspecial_info['message']
        }
    }

    return {
        'status': 'closed',
        'text': ''
    }
}

function checkifExistWorkingDay (opening_hours, day_number) {
    for (var i = 0; i < opening_hours.length; i++) {
        var value = opening_hours[i]
        if (value['day'] == day_number) { return true }
    }
    return false
}

function getCheckerbyDates (dn, ds, de, config_status = 'open', message = '', hlunch_info = Object, hspecial_info = Object) {
    var checker = {
        'status': 'closed',
        'text': '',
        'message': message
    }
    checker['text'] = Drupal.t("Today since @time o'clock", {'@time': de.format('H:mm')})

    if (dn >= ds && dn < de) {
        if (config_status != 'open') {
            if (hlunch_info['check']) {
                let interval = moment.duration(dn.diff(de))
                if (parseInt(interval.asHours()) == 0) {
                    checker.status = 'opening'
                }
            }
            checker['text'] = hlunch_info['check']
                ? Drupal.t("Lunch break until @lunch_til o'clock", {'@lunch_til': de.format('H:mm')})
                : Drupal.t("Today until @time o'clock", {'@time': de.format('H:mm') })
        } else {
            let interval = moment.duration(dn.diff(de))
            if (parseInt(interval.asHours()) == 0) {
                checker.status = 'closing'
                checker.text = Drupal.t("Today at @time o'clock", {'@time': de.format('H:mm') })
            } else {
                checker.status = 'open'
                checker.text = Drupal.t("Today until @time o'clock", {'@time': de.format('H:mm') })
                if (hlunch_info['date_start']) {
                    checker['text'] = Drupal.t('Lunch break from @lunch_start - @lunch_end',
                        {'@lunch_start': hlunch_info['date_start'].format('H:mm'), '@lunch_end': hlunch_info['date_end'].format('H:mm')})
                }
            }
        }
    } else if (dn < ds && config_status == 'open') {
        checker['text'] = Drupal.t("Today at @time o'clock", {'@time': ds.format('H:mm') })
        checker['status'] = 'opening'
    }
    // Overwrite if special hour is ready in the same day
    if (hspecial_info.length > 0) {
        if (hspecial_info['type'] == 'open' && checker['status'] == 'closed' && !hlunch_info['check']) {
            checker['text'] = Drupal.t("Today at @time o'clock", {'@time': hspecial_info['date_start'].format('H:m')})
            checker['status'] = 'opening'
            checker['message'] = hspecial_info['message']
        } else if (hspecial_info['type'] == 'closed' && !hlunch_info['check']) {
            if (checker['status'] == 'open' || checker['status'] == 'opening') {
                let interval = moment.duration(dn.diff(hspecial_info['date_start']))
                if (parseInt(interval.asHours()) == 0) {
                    checker['status'] = 'closing'
                    checker['text'] = Drupal.t("Today at @time o'clock", {'@time': hspecial_info['date_start'].format('H:m')})
                    checker['message'] = hspecial_info['message']
                }
            }
        }
    }
    return checker
}

function checkInRangeDay (start_date, end_date, date_from_user) {
    return moment(date_from_user).isBetween(start_date, end_date, undefined, '()')
}

function stringToDateTime (date_string) {
    let Stringdate = date_string.toString();
    let dateString = Stringdate.length === 3 ? '0' + Stringdate : Stringdate
    let hours = dateString.substring(0, 2)
    let minutes = dateString.substring(2)
    return moment().tz('Europe/Berlin').set({'hour': hours, 'minute': minutes, 'seconds': '00'})
}
function checkInRangeDate (date_now, date_start, date_end) {
    return (date_now >= date_start && date_now <= date_end)
}
function themeStatus (output,badge) {
    let statusTxt = ''
    let statusClass = 'bg-blue'
    if (output.status === 'open') {
        statusTxt = Drupal.t('Now open')
        statusClass = 'bg-success'
    } else if (output.status === 'closing') {
        statusTxt = Drupal.t('Closes soon')
    } else if (output.status === 'opening') {
        statusTxt = Drupal.t('Opens soon')
    } else {
        if (output.text.length > 0) {
            statusTxt = Drupal.t('Now closed')
            statusClass = 'bg-danger'
        } else {
            statusTxt = Drupal.t('Closed today')
            statusClass = 'bg-danger'
        }
    }

    let msgHtml = ''
    if (output.message && output.message.length > 0) {
        msgHtml = `
               <div class="store-status-comment mb-1">
                        <i class="fa fa-exclamation-circle active"></i>
                        <span>${output.message}</span>
               </div>`
    }
    if(badge==='m'){
        return `<div class="store-status">
        <div class="store-status-main align-items-center">
           <span class="badge-element d-inline-block border-radius-main badge-m text-white ${statusClass}">
               ${statusTxt}
           </span>
            <span class="text-black font-weight-500">  ${output.text && output.text.length > 0 ? ' - ' + output.text : ''}</span>
        </div>
         ${msgHtml}
       </div>`
    }

    return `<div class="store-status">
    <div class="store-status-main align-items-center">
       <span class="badge-element d-inline-block border-radius-main badge-l text-white ${statusClass}">
           ${statusTxt}
       </span>
        <span class="text-black font-weight-500">  ${output.text && output.text.length > 0 ? ' - ' + output.text : ''}</span>
    </div>
     ${msgHtml}
   </div>`

}

function buildStatus (data, badge) {
    return themeStatus(checkStatus(data),badge)
}

export { buildStatus }
